import React, { useEffect } from 'react'
import './App.css';
import {BrowserRouter} from 'react-router-dom';
import Routes from './Routes';
import {Template, Header, Footer} from './components';
import StickyPostButton from './components/StickyPostButton';
import chatSocketService from './helpers/ChatSocket';
import Cookies from 'js-cookie';
import { ToastProvider } from './components/NotificationToast';
import GoogleAnalytics from './components/Analytics/GoogleAnalytics';
import ErrorBoundary from './components/ErrorBoundary';

const App = () => {
  // Initialize WebSocket connection for all logged-in users
  useEffect(() => {
    const token = Cookies.get('token');
    if (token) {
      // Connect to WebSocket for presence tracking
      chatSocketService.connect(token);
      
      // Cleanup on unmount or page unload
      const handleBeforeUnload = () => {
        chatSocketService.disconnect();
      };
      
      window.addEventListener('beforeunload', handleBeforeUnload);
      
      return () => {
        // Disconnect when component unmounts or token changes
        window.removeEventListener('beforeunload', handleBeforeUnload);
        chatSocketService.disconnect();
      };
    } else {
      // Si no hay token, asegurar que no hay conexión
      chatSocketService.disconnect();
    }
  }, []);
  
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <GoogleAnalytics measurementId={process.env.REACT_APP_GA4_MEASUREMENT_ID} />
        <ToastProvider>
          <Template header={<Header />} footer={<Footer />}>
            <Routes />
            <StickyPostButton />
          </Template>
        </ToastProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default App;
